import { useContext } from 'react';
import { ReportsContext } from 'apps/sigma2-ui/src/reports/hooks/ReportsContext';

export const useReports = (): ReportsContext => {
  return useContext(ReportsContext);
};
